const initialState = {
  navigationDrawer: false,
  navigationDrawerMini: false,
};

const mutations = {
  NAVIGATION_DRAWER(state, payload) {
    state.navigationDrawer = payload;
  },
  NAVIGATION_DRAWER_MINI(state, payload) {
    state.navigationDrawerMini = payload;
  },
};

const actions = {
  toggleNavigationDrawer({ commit, state }) {
    commit('NAVIGATION_DRAWER', !state.navigationDrawer);
  },
  toggleNavigationDrawerMini({ commit, state }) {
    commit('NAVIGATION_DRAWER_MINI', !state.navigationDrawerMini);
  },
};

const getters = {
  navigationDrawer(state) {
    return state.navigationDrawer;
  },
  navigationDrawerMini(state) {
    return state.navigationDrawerMini;
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  getters,
};
